import { getStorage, ref, uploadBytesResumable, getDownloadURL, deleteObject } from "firebase/storage";
import { app } from "./firebase"; // Ensure you import your initialized Firebase app

const storage = getStorage(app);

export const uploadFile = (file, path, onProgress = () => {}) => {
    return new Promise((resolve, reject) => {
        const storage = getStorage();
        const storageRef = ref(storage, path);
        const uploadTask = uploadBytesResumable(storageRef, file);

        uploadTask.on(
            "state_changed",
            (snapshot) => {
                // 🔹 Calculate upload progress
                const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                onProgress(progress.toFixed(0)); // 🔹 Round to whole number
            },
            (error) => {
                console.error("❌ Error uploading file:", error);
                reject(error);
            },
            async () => {
                const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
                resolve(downloadURL);
            }
        );
    });
};

export const deleteFile = async (path) => {
    try {
        const storageRef = ref(storage, path);
        await deleteObject(storageRef);
        console.log("✅ File deleted successfully:", path);
    } catch (error) {
        console.error("❌ Error deleting file:", error);
    }
};

export { storage };
